import {useCallback, useContext} from 'react'

import {useDocumentSearchHandler} from '../../../../../../hooks/documentSearch'
import {useAppDispatch, useAppSelector} from '../../../../../../hooks/react-redux'
import {buildLogSearchHint} from '../../../../Hints/HintItems/Hints.buildOverview'
import {useHint} from '../../../../Hints/Hints.hooks'
import {getFullLogState} from '../../../BuildLog.selectors'
import {collapseAllMessages, expandAllMessages} from '../../FullBuildLog.actions'
import {TargetContext} from '../../FullBuildLog.context'
import {isSearchEnabled} from '../BuildLogSearch/BuildLogSearch.selectors'

function useBuildLogControls(setSearchActive: (searchActive: boolean) => unknown) {
  const target = useContext(TargetContext)
  const dispatch = useAppDispatch()

  const searchEnabled = useAppSelector(isSearchEnabled)
  const messagesExists = useAppSelector(state => getFullLogState(state, target).messagesExists)
  const filter = useAppSelector(state => getFullLogState(state, target).filter)

  const onExpandAllClick = useCallback(() => {
    dispatch(expandAllMessages(target))
  }, [dispatch, target])

  const onCollapseAllClick = useCallback(() => {
    dispatch(collapseAllMessages(target))
  }, [dispatch, target])

  const showSearch = useCallback(() => {
    setSearchActive(true)
  }, [setSearchActive])

  useHint(buildLogSearchHint)
  useDocumentSearchHandler(searchEnabled && messagesExists, showSearch)

  return {
    filterValue: filter,
    searchEnabled,
    messagesExists,
    showSearch,
    onExpandAllClick,
    onCollapseAllClick,
  }
}

export default useBuildLogControls
